import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  exp: number;
}

export const isTokenExpired = (token?: string): boolean => {
  if (!token) return true;
  const decoded = jwtDecode<DecodedToken>(token);
  const currentTime = Date.now() / 1000;
  return decoded.exp < currentTime;
};

export const logout = (): void => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};
